module.exports = __webpack_public_path__ + "static/media/9DESA17.1f3211e4.jpg";